import $ from "jquery";

/*===============================================================================================*/
/* This code binds to the file input and remove button and works with the validation logic
/*   to show the validation error messages.
/*   - This code works with validate_input_file function in abide.js.  The validate_input_file
/*      checks file size and content type and then adds data-invalid, invalid-* classes for
/*      each class of failed validation.
/*===============================================================================================*/
$(document).ready(function () {
    if (!document.getElementsByClassName(".file-uploader-remove")) {
        return;
    };

    var classIds = ["id-file1", "id-file2", "id-file3"];

    for (var key in classIds) {
        $("." + classIds[key]).on('change',onInputChange);
        $("." + classIds[key]).siblings('.file-uploader-remove').click(onClickRemove);
    }

    var errorMessageHelper = ErrorMessageHelper(".id-upload-error-output",".id-upload-error-message");

    function onInputChange()
    {
        errorMessageHelper.processChange();
    }
    
    function onClickRemove(evt)
    {
        var inputElem = evt.currentTarget.parentElement.children[0];
        inputElem.removeAttribute("data-invalid");
        inputElem.removeAttribute("invalid-file-size-too-small");
        inputElem.removeAttribute("invalid-file-size-too-large");
        inputElem.removeAttribute("invalid-content-type");
        inputElem.removeAttribute("invalid-non-unique-filename");
        inputElem.classList.remove("is-invalid-input");
        errorMessageHelper.processChange();
    }

    function getDisplayName(inputClassID)
    {
        if (inputClassID == "id-file1") return "File 1";
        if (inputClassID == "id-file2") return "File 2";
        if (inputClassID == "id-file3") return "File 3";
        return inputClassID;
    }

    function ErrorMessageHelper(containerId, messageId)
    {
        var obj = {
            reset: reset,
            addMessage: addMessage,
            show: show,
            processChange: processChange,
            messages: []
        };
        obj.elContainer = $(containerId);
        obj.elMessages = $(messageId);
        return obj;

        function reset()
        {
            obj.messages = [];
            obj.elContainer.addClass("hide");
        }

        function addMessage(message)
        {
            obj.messages.push(message);
        }

        function show()
        {
            obj.elMessages.empty();
            for (var key in obj.messages) {
                var msg = obj.messages[key];
                obj.elMessages.append("<li>" + msg + "</li>");
            }
            obj.elContainer.removeClass("hide");
            obj.elContainer.children(".callout").attr('style', function(i, style)
            {
                return style && style.replace(/display[^;]+;?/g, '');
            });
        }

        function processChange()
        {
            var valid = true;            
            for (var key in classIds) {
                var elem = $("." + classIds[key]);
                if (elem.attr('data-invalid')!=undefined)
                {
                    if (valid) errorMessageHelper.reset();
                    valid = false;
                    var name = getDisplayName(classIds[key]);
                    var message = "";
                    var filename = "";
                    if (elem && elem.length > 0 && elem[0].files && elem[0].files.length > 0) {
                        filename = elem[0].files[0].name;  // could be updated to support multiple file
                    };
                    if (elem.attr("invalid-file-size-too-small")!=undefined) {
                        message = " is too small";
                    }
                    if (elem.attr("invalid-file-size-too-large")!=undefined) {
                        message = " is too big";
                    }
                    if (elem.attr("invalid-non-unique-filename")!=undefined) {
                        message = " filename is already used";
                    }
                    if (elem.attr("invalid-content-type")!=undefined) {
                        if (message && message.length > 0) {
                            message = message + " and of an invalid file type";
                        } else {
                            message = " is of an invalid file type";
                        }
                    }
                    if (message && message.length > 0) {
                        errorMessageHelper.addMessage(filename + " (" + name + ")" + message);
                    }
                    
                }
            };
            if (!valid) {
                errorMessageHelper.show();
            } else {
                errorMessageHelper.reset();
            }
        }        
    };
});